import Logger from './Logger';

const logger = new Logger('Spotlight');

export default class Spotlights
{
	constructor(maxSpotlights, hideNoVideoParticipants, roomClient)
	{
		this._maxSpotlights = maxSpotlights;
		this._peerList = [];
		this._activeVideoConsumers = [];
		this._selectedSpotlights = [];
		this._currentSpotlights = [];
		this._roomClient = roomClient;
		this._hideNoVideoParticipants = hideNoVideoParticipants;
		this._videoPeerList = [];
		this._debounceTimer = null;
		this._handlePeerCloseTimmer=null
	}

	// Debounced implementation for _spotlightsUpdated calls
	_debouncedSpotlightsUpdate()
	{
		// Clear any existing timer
		if (this._debounceTimer)
		{
			clearTimeout(this._debounceTimer);
		}

		// Set a new timer to execute the update after a short delay
		this._debounceTimer = setTimeout(() =>
		{
			this._spotlightsUpdated();
			this._debounceTimer = null;
		}, 500); // 10ms delay - very short to ensure responsiveness
	}

	addPeers(peers)
	{
		for (const peer of peers)
		{
			if (this._peerList.indexOf(peer.id) === -1 && !peer.screenShare)
			{
				logger.debug('adding peer [peerId: "%s"]', peer.id);
				this._peerList.push(peer.id);
				if (peer.video)
				{
					this._videoPeerList.push(peer.id);
				}
			}
		}

		window.peerListB = this._peerList;

		this._debouncedSpotlightsUpdate();
	}

	removePeerFromVideoPeerList(peerId)
	{
		this._videoPeerList = this._videoPeerList.filter((peer) => peer !== peerId);
		if (this._currentSpotlights.indexOf(peerId) > -1)
		{
			this._debouncedSpotlightsUpdate();
		}
	}

	addPeerToVideoPeerList(peerId)
	{
		this._videoPeerList.push(peerId);
		if (this._currentSpotlights.indexOf(peerId) > -1)
		{
			this._requestConsumersForVideoPeers();
		}
		else if (this._hideNoVideoParticipants)
		{
			this._debouncedSpotlightsUpdate();
		}
	}

	peerInSpotlights(peerId)
	{
		return this._currentSpotlights.indexOf(peerId) !== -1;
	}

	addPeerToSelectedSpotlights(peerId)
	{
		logger.debug('addPeerToSpotlight() [peerId:"%s"]', peerId);

		this._selectedSpotlights = [ ...this._selectedSpotlights, peerId ];
		this._debouncedSpotlightsUpdate();
	}

	removePeerFromSelectedSpotlights(peerId)
	{
		logger.debug('removePeerSpotlight() [peerId:"%s"]', peerId);

		this._selectedSpotlights =
			this._selectedSpotlights.filter((peer) =>
				peer !== peerId);

		this._debouncedSpotlightsUpdate();
	}

	clearPeersFromSelectedSpotlights()
	{
		logger.debug('clearPeersFromSpotlights()');

		this._selectedSpotlights = [];

		this._debouncedSpotlightsUpdate();
	}

	clearSpotlights()
	{
		this._peerList = [];
		this._activeVideoConsumers = [];
		this._selectedSpotlights = [];
		this._currentSpotlights = [];
		this._videoPeerList = []

		if (Number(this._roomClient._screenPage) > 0)
		{
			this._debouncedSpotlightsUpdate();
		}
	}

	newPeer(id)
	{
		logger.debug(
			'room "newpeer" event [id: "%s"]', id);

		if (this._peerList.indexOf(id) === -1) // We don't have this peer in the list
		{
			logger.debug('_handlePeer() | adding peer [peerId: "%s"]', id);

			this._peerList.push(id);

			// if (this._peerList.length <= this._maxSpotlights)
			// {

			// 	this._currentSpotlights.push(id);

			// 	this._roomClient.updateSpotlights(this._currentSpotlights);
			// }
			this._debouncedSpotlightsUpdate();
		}

		// window.peerListA = this._peerList;
	}

	// closePeer(id)
	closePeer(id, spotlights)
	{
		logger.debug(
			'room "peerClosed" event [peerId:%o]', id);

		this._peerList = this._peerList.filter((peer) => peer !== id);
		this._videoPeerList = this._videoPeerList.filter((peer) => peer !== id);
		this._activeVideoConsumers = this._activeVideoConsumers.filter((consumer) =>
			consumer.peerId !== id);
		this._selectedSpotlights = this._selectedSpotlights.filter((peer) => peer !== id);
		if (this._currentSpotlights.indexOf(id) > -1)
		{
			// this._debouncedSpotlightsUpdate();
			this.updateSpotligtsafterPeerClose(spotlights);
		}
	}

	addSpeakerList(speakerList)
	{
		this._peerList = [ ...new Set([ ...speakerList, ...this._peerList ]) ];
		// window.peerListC = this._peerList;
		this._debouncedSpotlightsUpdate();
	}

	updateSpotligtsafterPeerClose(spotlights)
	{
		if(this._handlePeerCloseTimmer){
			clearTimeout(this._handlePeerCloseTimmer);
		}
		this._handlePeerCloseTimmer=setTimeout(()=>{
			
			let updatedSpotlights = [];
	
			while (this._selectedSpotlights.length > this._maxSpotlights)
			{
				this._selectedSpotlights.shift();
			}
	
			updatedSpotlights = [ ...new Set([ ...this._selectedSpotlights, ...spotlights, ...this._peerList ]) ];
	
			if (!this._arraysEqual(
				this._currentSpotlights, updatedSpotlights.slice(0, this._maxSpotlights)))
			{
				logger.debug('_spotlightsUpdated() | spotlights updated, emitting');
	
				this._currentSpotlights = updatedSpotlights.slice(0, this._maxSpotlights);
				this._roomClient.updateSpotlights(this._currentSpotlights);
				this._requestConsumersForVideoPeers();
			}
			else
			{
				logger.debug('_spotlightsUpdated() | spotlights not updated');
			}
		},500)
		// let updatedSpotlights = [];

		// while (this._selectedSpotlights.length > this._maxSpotlights)
		// {
		// 	this._selectedSpotlights.shift();
		// }

		// updatedSpotlights = [ ...new Set([ ...this._selectedSpotlights, ...spotlights ]) ];

		// if (!this._arraysEqual(
		// 	this._currentSpotlights, updatedSpotlights.slice(0, this._maxSpotlights)))
		// {
		// 	logger.debug('_spotlightsUpdated() | spotlights updated, emitting');

		// 	this._currentSpotlights = updatedSpotlights.slice(0, this._maxSpotlights);
		// 	this._roomClient.updateSpotlights(this._currentSpotlights);
		// }
		// else
		// {
		// 	logger.debug('_spotlightsUpdated() | spotlights not updated');
		// }

	}

	handleActiveSpeaker(peerId)
	{
		logger.debug('handleActiveSpeaker() [peerId:"%s"]', peerId);
		const moveToFront = (array, id) =>
		{
			const index = array.indexOf(id);

			if (index > -1)
			{
				array.splice(index, 1);
				array.unshift(id);

				return true;
			}

			return false;
		};
		const peerMoved = moveToFront(this._peerList, peerId);
		const videoPeerMoved = moveToFront(this._videoPeerList, peerId);

		if ((peerMoved || videoPeerMoved) && this._currentSpotlights.indexOf(peerId) <= -1)
		{
			this._debouncedSpotlightsUpdate();
		}
	}

	addVideoConsumer(newConsumer)
	{
		if (newConsumer.kind === 'video' && (newConsumer.source === 'webcam' ||
			newConsumer.source === 'extravideo' || newConsumer.source === 'screen') &&
			this._activeVideoConsumers.findIndex((consumer) =>
				consumer.consumerId === newConsumer.id) === -1)
		{
			this._activeVideoConsumers.push({
				consumerId     : newConsumer.id,
				peerId         : newConsumer.peerId,
				remotelyPaused : newConsumer.remotelyPaused });

			// this._spotlightsUpdated();
			if (this._currentSpotlights.indexOf(newConsumer.peerId) > -1)
			{
				console.log('addVideoConsumer');
				this._roomClient.updateSpotlights(this._currentSpotlights);
			}
		}
	}

	removeVideoConsumer(consumerId)
	{
		// const oldLength = this._activeVideoConsumers.length;

		// this._activeVideoConsumers = this._activeVideoConsumers.filter((consumer) =>
		// 	consumer.consumerId !== consumerId);

		// if (oldLength !== this._activeVideoConsumers.length)
		// 	this._spotlightsUpdated();
		const vIndex = this._activeVideoConsumers.findIndex((consumer) => consumer.consumerId === consumerId);
		const videoConsumer = this._activeVideoConsumers[vIndex];

		if (videoConsumer && videoConsumer.peerId)
		{
			this._activeVideoConsumers.splice(vIndex, 1);
			if (this._currentSpotlights.indexOf(videoConsumer.peerId) > -1)
			{
				this._roomClient.updateSpotlights(this._currentSpotlights);
			}
		}

	}

	resumeVideoConsumer(consumerId)
	{
		const videoConsumer = this._activeVideoConsumers.find((consumer) =>
			consumer.consumerId === consumerId);

		if (videoConsumer)
		{
			videoConsumer.remotelyPaused = false;
			// this._spotlightsUpdated();
			if (this._currentSpotlights.indexOf(videoConsumer.peerId) > -1)
			{
				this._roomClient.updateSpotlights(this._currentSpotlights);
			}
		}
	}

	pauseVideoConsumer(consumerId)
	{
		const videoConsumer = this._activeVideoConsumers.find((consumer) =>
			consumer.consumerId === consumerId);

		if (videoConsumer)
		{
			videoConsumer.remotelyPaused = true;
			// this._spotlightsUpdated();
			if (this._currentSpotlights.indexOf(videoConsumer.peerId) > -1)
			{
				this._roomClient.updateSpotlights(this._currentSpotlights);
			}
		}
	}

	_donthaveActiveVideo(peerId)
	{
		console.log('this._activeVideoConsumers', [...this._activeVideoConsumers]);
		console.log('peerId', peerId);
		if (this._activeVideoConsumers.findIndex((consumer) =>
			consumer.peerId === peerId && !consumer.remotelyPaused) !== -1)
		{
			return false;
		}

		return true;
	}

	_spotlightsUpdated()
	{
		// console.log('this._peerListthis._peerList', this._peerList);
		let spotlights;

		if (Number(this._roomClient._screenPage) > 0)
		{
			return;
		}

		if (this._roomClient._mode === 'speaker' || this._roomClient._mode === 'screen')
		{
			// if (this._peerList?.length > 0)
			// {

			this._roomClient.updateSpotlights(this._peerList);
			// }

			return;
		}
		// else if (Number(this._roomClient._screenPage) > 0)
		// {
		// 	console.log('this._currentSpotlights==', this._peerList);
		// 	this._roomClient.updateSpotlights(this._peerList);

		// 	return;
		// }
		// else if (this._mode === 'screen')
		// {
		// 	this._roomClient.updateSpotlights(this._peerList);
		// }

		if (this._hideNoVideoParticipants)
		{
			// spotlights = this._peerList.filter((peerId) =>
			// 	this._hasActiveVideo(peerId));
			spotlights = this._videoPeerList;
		}
		else
		{
			spotlights = this._peerList;
		}

		while (this._selectedSpotlights.length > this._maxSpotlights)
		{
			this._selectedSpotlights.shift();
		}

		if (this._selectedSpotlights.length > 0)
		{
			spotlights = [ ...new Set([ ...this._selectedSpotlights, ...spotlights ]) ];
		}

		// console.log('spotlights======', spotlights);

		if (!this._arraysEqual(
			this._currentSpotlights, spotlights.slice(0, this._maxSpotlights)))
		{
			logger.debug('_spotlightsUpdated() | spotlights updated, emitting');

			this._currentSpotlights = spotlights.slice(0, this._maxSpotlights);
			this._roomClient.updateSpotlights(this._currentSpotlights);
			this._requestConsumersForVideoPeers();
		}
		else
		{
			logger.debug('_spotlightsUpdated() | spotlights not updated');
		}

		window.currentSpotlights = this._peerList;
	}

	_requestConsumersForVideoPeers()
	{
		const sendList = this._currentSpotlights.filter((peerId) =>
			this._donthaveActiveVideo(peerId));

		console.log('sendList', sendList);
		if (sendList.length > 0)
			this._roomClient.sendRequest('createConsumerForPeer', { peerList: sendList });
	}

	_arraysEqual(arr1, arr2)
	{
		if (arr1.length !== arr2.length)
			return false;

		for (let i = arr1.length; i--;)
		{
			if (arr1[i] !== arr2[i])
				return false;
		}

		return true;
	}

	get hideNoVideoParticipants()
	{
		return this._hideNoVideoParticipants;
	}

	set hideNoVideoParticipants(hideNoVideoParticipants)
	{
		const oldHideNoVideoParticipants = this._hideNoVideoParticipants;

		this._hideNoVideoParticipants = hideNoVideoParticipants;

		if (oldHideNoVideoParticipants !== this._hideNoVideoParticipants)
			this._debouncedSpotlightsUpdate();
	}

	get maxSpotlights()
	{
		return this._maxSpotlights;
	}

	set maxSpotlights(maxSpotlights)
	{
		const oldMaxSpotlights = this._maxSpotlights;

		this._maxSpotlights = maxSpotlights;

		if (oldMaxSpotlights !== this._maxSpotlights)
			this._debouncedSpotlightsUpdate();
	}
}
